module.exports = __webpack_public_path__ + "img/img_loginvisual_user.27d96cf.png";